import { Pause } from "lucide-react";
import { SLA_DOT, SLA_TEXT } from "@/lib/labels";

export default function SlaBadge({ sla }) {
  if (!sla) return <span className="text-xs text-muted-foreground">—</span>;
  const overdue = sla.pct >= 100;
  let text;
  if (sla.concluded) text = overdue ? "Concluída fora do prazo" : "Concluída no prazo";
  else if (sla.paused) text = "Pausado";
  else if (overdue) text = `Estourado há ${Math.abs(sla.remaining_hours).toFixed(0)}h`;
  else text = `${sla.remaining_hours.toFixed(0)}h restantes`;
  return (
    <span className="inline-flex items-center gap-1.5 whitespace-nowrap" data-testid="sla-badge">
      {sla.paused && !sla.concluded ? (
        <Pause size={11} className="text-violet-400" />
      ) : (
        <span className={`h-2 w-2 rounded-full shrink-0 ${SLA_DOT[sla.color]} ${overdue && !sla.concluded ? "animate-pulse" : ""}`} />
      )}
      <span className={`text-xs font-medium ${sla.paused && !sla.concluded ? "text-violet-400" : SLA_TEXT[sla.color]}`}>{text}</span>
    </span>
  );
}
